var Highcharts = require('highcharts/highcharts-gantt');

export class OptNowActivationPage {
	siteData: any;

	constructor(siteData: any) {
		this.siteData = siteData;

		$(() => {
			var day_ms = 24 * 60 * 60 * 1000;
			var tab_blue = '#6699CC';
            var tab_orange = '#532565';
            var df_sites = Object.keys(siteData); console.log('df_sites', df_sites);
            var df_cols = Object.keys(Object.values(siteData)[1]).slice(1); console.log('df_cols', df_cols);

            var start_dates = [];
            Object.values(siteData).map(function (item) {
                start_dates.push(item['StartDate']);
                delete item['StartDate'];
                return item;
            });

			// get all of the categories from the site data
			var cols = Object.keys(Object.values(siteData)[1]);

			// get all of the date values
			var gantt_vals = Object.values(siteData).map(k => Object.values(k).filter(j => j != null).reduce((acc, c) => acc + 1, 0) / 12);

			var gantt_color = gantt_vals.map(x => x == 1 ? tab_blue : tab_orange);

            var datadata = [];
            for (var i = 0; i < df_sites.length; i += 1) {
                datadata.push({ name: df_sites[i], data: [] })
                for (var j = 0; j < df_cols.length; j += 1) {
                    var start_dt = (Object.values(siteData)[i][df_cols[j]]) == null ? null : j;
                    var end_dt = (start_dt == null ? null : j + 1)

                    datadata[i].data = [...datadata[i].data,
                    ...[{
                        name: df_cols[j],
                        y: i,
                        start: start_dt,
                        end: end_dt,
                        color: gantt_color[i]
                    }]];
                };
            };
            console.log('datadata', datadata);


			var cols_plus = [...cols, ...['']];

            Highcharts.ganttChart('div_1', {
                
                credits: { enabled: false },
                title: { text: 'OPTimize NOW' },
                subtitle: { text: 'Site Activation Progress' },
                series: datadata,
                yAxis: { categories: Object.keys(siteData) },
                xAxis: [{
                    categories: cols_plus,
                    labels: { align: 'left' },  //enabled:false},  // min:0, max:11,  startOnTick: true, minPadding:0,
                    grid: { enabled: false },
                    tickInterval: 1,
                    max: cols_plus.length - 1
                },
                { visible: false }],
                tooltip: {
                    useHTML: true,
                    formatter: function () {
                        var point_date = Object.entries(siteData)[this.y][1][this.key]
                        // let parent = (this.point.parent) ? (this.point.parent) : this.key;
                        return Object.keys(siteData)[this.y] + ' (' + Math.round(gantt_vals[this.y] * 100) + '% Complete)'
                            + '<br/>' + this.key + ' (' + Highcharts.dateFormat('%d %b %Y', point_date) + ')'
                        // + '<br/>' + HighC.dateFormat('%d %b %Y', point_date) 
                    }
                }
            });
            
            // div_2 = "% Complete by Site"
            var task_comp = [];
            for (var i = 0; i < Object.keys(siteData).length; i += 1) { task_comp.push(Math.round(gantt_vals[i] * 100)) };
            var bar_missing = Object.values(siteData).map(k => Object.values(k).map((e, i) => (e == null) ? cols[i] + '<br/>' : '').filter(String));

            // sort sites by completion%
            var site_task_comp = [];
            for (var i = 0; i < Object.keys(siteData).length; i += 1) { site_task_comp.push([Object.keys(siteData)[i], Math.round(gantt_vals[i] * 100)]) };

            var site_task_comp_sort = site_task_comp.sort(function (a, b) { return b[1] - a[1] });


            Highcharts.chart('div_2', {
                credits: { enabled: false },
                chart: { type: 'bar', height: 599 },
                title: { text: 'Overall Activation Completion %' },
                legend: { enabled: false },
                tooltip: { //enabled: false},
                    formatter: function () {
                        return this.x + ': ' + this.y + '%';
                    }
                },
                xAxis: { categories: site_task_comp_sort.map(x => x[0]) },
                yAxis: {
                    title: false, //{text:''}, 
                    endOnTick: false,
                    min: 0, max: 100
                },
                series: [{ data: site_task_comp_sort.map(x => x[1]) }],
                colors: gantt_color, plotOptions: { bar: { colorByPoint: false } },
            });







            // div_3  - IRB & contract status

            // IRB gantt
            var IRB_gantt_vals = Object.values(siteData).map(k => [...Object.values(k).slice(0, 4), ...Object.values(k).slice(-1)].filter(j => j != null).reduce((a, c) => a + 1, 0) / 5);
            var IRB_gantt_color = IRB_gantt_vals.map(x => x == 1 ? tab_blue : tab_orange); //'#2caffe':'#FEB56A')

            var IRB_cols = [...df_cols.slice(0, 4), ...df_cols.slice(-1)];
            var IRB_cols_plus = [...IRB_cols, ...['']];

            var dd2 = [];
            for (var i = 0; i < Object.keys(siteData).length; i += 1) {  //rows
                dd2.push({ name: Object.keys(siteData)[i], data: [] });
                for (j = 0; j < IRB_cols.length; j += 1) {
                    var start_dt = (Object.values(siteData)[i][IRB_cols[j]]) == null ? null : j;
                    var end_dt = (start_dt == null ? null : j + 1);

                    dd2[i].data = [...dd2[i].data,
                    ...[{
                        name: IRB_cols[j],
                        y: i,
                        start: start_dt, //Object.values(site_sites)[i][cols[j]],
                        end: end_dt,
                        color: IRB_gantt_color[i]
                    }]];
                };
            };

     
            var chart_3 = Highcharts.ganttChart('div_3', {
                credits: { enabled: false },
                title: { text: 'OPTimize NOW' },
                subtitle: { text: 'IRB' },
                series: dd2,
                yAxis: { categories: Object.keys(siteData), showLastLabel:true },
                xAxis: [{
                    categories: IRB_cols_plus,

                    labels: { align: 'left' },  //enabled:false},  // min:0, max:11,  startOnTick: true, minPadding:0,
                    grid: { enabled: false },
                    tickInterval: 1
                },
                { visible: false }
                ],
                tooltip: {
                    useHTML: true,
                    formatter: function () {
                        var point_date = Object.entries(siteData)[this.y][1][this.key]
                        return Object.keys(siteData)[this.y] + ' (' + Math.round(gantt_vals[this.y] * 100) + '% Complete)'
                            + '<br/>' + this.key + ' (' + Highcharts.dateFormat('%d %b %Y', point_date) + ')';
                    }
                }
            });

            // mitigate space btw yAxis & values
            window.addEventListener('load', load_funct);
            function load_funct() {
                resize_funct();
                window.addEventListener('resize', resize_funct);
            }
            function resize_funct() {
                // var y_offset = -1 * 1.0077**chart_1.chartWidth/chart_1.chartHeight;
                var y_offset = -1 * 1.00133 ** chart_3.chartWidth;
                chart_3.update({ yAxis: { offset: y_offset } });
            }

            /*
            // // div_4 = "% Complete by Site"
            var IRB_max = Object.values(siteData).map(k => Math.max(...[...Object.values(k).slice(0, 4), ...Object.values(k).slice(-1)]));

            var IRB_t2c = []
            // // if (start_dates.length == IRB_max.length) {
            for (var i = 0; i < start_dates.length; i += 1) {
                if (IRB_max[i] > 0) {
                    IRB_t2c.push((IRB_max[i] - start_dates[i]) / 86400000);
                } else {
                    IRB_t2c.push(0);
                    // IRB_t2c.push(1)
                }
            }
            

            Highcharts.chart('div_4', {
                credits: { enabled: false },
                chart: { type: 'bar', height: 599 },
                title: { text: 'IRB and Contract Status' },
                subtitle: { text: 'Time to Completion' },
                legend: { enabled: false },
                tooltip: { //enabled: false},
                    formatter: function () {
                        return this.x + ' - Time to Completion: ' + this.y + ' days';
                    }
                },
                xAxis: { categories: Object.keys(siteData) },
                yAxis: {
                    title: false, //{text:''}, 
                    endOnTick: false
                },
                series: [{ data: IRB_t2c }],
                colors: IRB_gantt_color, plotOptions: {
                    bar: { colorByPoint: true }, series: { pointWidth: 20 }
                },
            });
            */
		});
	}
}